<!--
 * @Description: 申请开票-开票备注。应返回发票 维护中的备注
 * @Date: 2025-05-20 15:57:04
-->
<template>
  <BaseForm ref="formRef" label-position="top" :model="formData">
    <div class="form-dialog__title">
      <h1>开票备注</h1>
    </div>
    <div class="form-dialog__content">
      <BaseFormItem label="备注" prop="demand">
        <BaseInput
          class="form-dialog__w280"
          type="textarea"
          placeholder="请输入"
          show-word-limit
          :rows="4"
          :maxlength="120"
          v-model="formData.demand"
        ></BaseInput>
      </BaseFormItem>
    </div>
  </BaseForm>
</template>

<script lang="tsx" setup>
import { ref } from 'vue';
import { BaseForm, BaseFormItem, BaseInput } from 'xrk-components';
import { MakeOutAnInvoiceParams } from '@V/invoice/src/data-source/types';

const formRef = ref(null);
const formData = defineModel<MakeOutAnInvoiceParams>();
</script>
